import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { DateFilterTypes } from '../common/enums/date-filter-enums';
import { RecoveryTypes } from '../common/enums/recovery-enums';
import { CommonDialogService } from '../common/services/common-dialog.service';
import { PageLoaderService } from '../common/services/page-loader.service';
import { SharedService } from '../common/services/shared-service';
import { Eliminados } from '../common/types/eliminados.type';
import { RecoveryService } from './services/recovery.service';

@Component({
    selector: 'app-deleted-leaves',
    templateUrl: './deleted-leaves.component.html',
    styleUrls: ['./deleted-leaves.component.scss'],
    standalone: false
})
export class DeletedLeavesComponent implements OnInit {
 
    public abreviacions: string[] = [];
    // public searchResults: Eliminados[] = [];
    public searchResults = new MatTableDataSource<Eliminados>([]);
    public form: UntypedFormGroup;
    public isSearching = false;

    DateFilterType = DateFilterTypes;
    displayedColumns = ['fechaEliminacion', 'usuario', 'nomEmp', 'nomTrab', 'fbaja', 'motivo', 'recoveryButton'];

    constructor(
        private recoveryService: RecoveryService,
        private sharedService: SharedService,
        private fb: UntypedFormBuilder,
        private dialogService: CommonDialogService,
        private pageLoader: PageLoaderService,
        private changeDetector: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.initForm();
        this.loadAbrevacions();
    }


    /**
     * Load users abrevacions into drop down
     */
    private loadAbrevacions() {
        setTimeout(() => this.pageLoader.ShowPageLoader(), 0);

        this.recoveryService
            .getUsersAbreviacions()
            .pipe(
                finalize(() => this.pageLoader.HidePageLoader())
            )
            .subscribe(res => {

                if (res.code === 0)
                    this.abreviacions = res.result;
                else {
                    console.error(res.message);
                    this.sharedService.ShowSnackBar("Lo sentimos, ha fallado la carga de la lista de usuarios");
                }

            }, err => {
                console.error(err);
                this.sharedService.ShowSnackBar("Lo sentimos, ha fallado la carga de la lista de usuarios");
            });
    }


    /**
     * Initialize filter form
     */
    private initForm() {
        this.form = this.fb.group({
            trabajador: null,
            abreviacion: null,
            tipo: "T",
            fromDate: null,
            toDate: null,
        });
    }


    /**
     * Search event handler
     */
    public onSearch() {
        this.isSearching = true;
        const searchModel = this.recoveryService.buildSearchModel(this.form);

        this.recoveryService
            .searchEliminatedRecords(searchModel)
            .pipe(
                finalize(() => this.isSearching = false)
            )
            .subscribe(res => {
                if (res.code === 0)
                    this.searchResults.data = res.result;
                else {
                    console.error(res.message);
                    this.sharedService.ShowSnackBar("Lo sentimos, la búsqueda de registros eliminados ha fallado");
                }
            }, err => {
                console.error(err);
                this.sharedService.ShowSnackBar("Lo sentimos, la búsqueda de registros eliminados ha fallado");
            });
    }


    /**
     * Recovery event handler
     */
    public async onRecover(eliminatedRecord: Eliminados) {

        // get user confirmation to recover
        if (!(await this.getUserConfirmation(eliminatedRecord.tipo as RecoveryTypes)))
            return;

        // recover
        this.pageLoader.ShowPageLoader();
        const res = await this.Recover(eliminatedRecord);

        // display message according to recovered record
        if (res) {

            if (eliminatedRecord.tipo === RecoveryTypes.Employee)
                this.sharedService.ShowSnackBar("Trabajador recuperado");
            else if (eliminatedRecord.tipo === RecoveryTypes.Leave)
                this.sharedService.ShowSnackBar("Baja recuperada");

            // remove record
            _.remove(this.searchResults.data, (e) => e === eliminatedRecord);
            this.searchResults._updateChangeSubscription();

        } else {
            this.sharedService.ShowSnackBar("Lo siento, la recuperación ha fallado");
        }

        this.pageLoader.HidePageLoader();

    }


    /**
     * Get user confirmation to recover a record
     */
    private async getUserConfirmation(recoveryType: RecoveryTypes) {
        // build title
        let msg: string;
        if (recoveryType === RecoveryTypes.Employee)
            msg = "¿Recuperar el trabajador, todas sus bajas, actuaciones y tareas?";
        else if (recoveryType === RecoveryTypes.Leave)
            msg = "¿Recuperar la baja, con todas sus actuaciones y tareas?";

        // open dialog
        const dialogRef = this.dialogService.openConfirmationDialog(msg);
        return await dialogRef.afterClosed().toPromise() as boolean;
    }


    /**
     * Recover a record
     * @param eliminatedRecord Recovery data
     * @returns True if record is recovered
     */
    private async Recover(eliminatedRecord: Eliminados) {
        try {

            const res = await this.recoveryService.recover(eliminatedRecord).toPromise();

            if (res.code === 0)
                return true;
            else {
                console.error(res.message);
                return false;
            }

        } catch (error) {
            console.error(error);
            return false;
        }
    }


    // due to bad implementation of date range field I have to put this function here but totally useless
    public SetFilterValues(filterType: string, data: Date = null, selection: any = null): void {
    }

}
